import { createSlice } from "@reduxjs/toolkit";

export const cashPaymentsAccountsSlice = createSlice({
  name: "cashpaymentsaccounts",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    cashPaymentsAccountslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    cashPaymentsAccountsParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getCashPaymentsAccounts: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    cashPaymentsAccountsListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.cashPaymentsAccountsParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        cashPaymentsAccountslist: action.payload.response.results,
        loading: false,
        cashPaymentsAccountsParams: {
          ...state.cashPaymentsAccountsParams,
          no_of_pages: noofpages,
        },
      };
    },
    cashPaymentsAccountsAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    cashPaymentsAccountsAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    cashPaymentsAccountsEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    cashPaymentsAccountsEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    cashPaymentsAccountsDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetCashPaymentsAccountsParams: (state, action) => {
      return {
        ...state,
        cashPaymentsAccountsParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getCashPaymentsAccounts,
  cashPaymentsAccountsListSuccessful,
  cashPaymentsAccountsAdd,
  cashPaymentsAccountsAddSuccessful,
  cashPaymentsAccountsEdit,
  cashPaymentsAccountsEditSuccessful,
  cashPaymentsAccountsDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetCashPaymentsAccountsParams
} = cashPaymentsAccountsSlice.actions;

export default cashPaymentsAccountsSlice.reducer;
